import styles from './ConfirmModal.module.css';

interface Props {
  open: boolean; title: string; message: string;
  confirmLabel?: string; cancelLabel?: string; danger?: boolean;
  /** In-Flight-Guard: deaktiviert Confirm, Cancel und Backdrop-Close, solange die bestätigte Aktion läuft. */
  busy?: boolean;
  /** Progress-Label für den Confirm-Button, solange busy (Fallback: confirmLabel). */
  busyLabel?: string;
  /** Label für einen optionalen dritten Button zwischen Abbrechen und Bestätigen. */
  secondaryLabel?: string;
  /**
   * Abbrechen-Knopf ausblenden (Self-Service-Konfliktdialog, Spec 2026-09-15 §7:
   * dort wirkte „Abbrechen" wie „Meine behalten"). Standard: sichtbar.
   */
  hideCancel?: boolean;
  /** Klick auf den Hintergrund schliesst den Dialog (ruft `onCancel`). Standard: true. */
  dismissible?: boolean;
  onConfirm: () => void; onCancel?: () => void;
  onSecondary?: () => void;
}

export default function ConfirmModal({ open, title, message, confirmLabel = 'Bestätigen', cancelLabel = 'Abbrechen', danger = false, busy = false, busyLabel, secondaryLabel, hideCancel = false, dismissible = true, onConfirm, onCancel, onSecondary }: Props) {
  if (!open) return null;
  // Dreiwege-Dialog (drei Knoepfe): breitere Karte, damit die Reihe nicht
  // umbricht, und der Bestaetigen-Knopf als Primaeraktion — bei `danger`
  // behaelt die Warnfarbe Vorrang.
  const dreiWege = Boolean(secondaryLabel && onSecondary);
  const confirmClass = danger ? styles.pillDanger : dreiWege ? styles.pillPrimary : styles.pill;
  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true" aria-label={title} onClick={busy || !dismissible ? undefined : onCancel}>
      <div className={dreiWege ? styles.cardWide : styles.card} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          {/* Dreiwege-Dialog: „Verwerfen" sitzt links und traegt die Warnfarbe —
              es ist die einzige Handlung, die etwas wegwirft. Rechts die beiden
              harmlosen: „Bleiben" und, als Primaeraktion ganz aussen,
              „Speichern". Zweiwege-Dialoge bleiben unveraendert rechtsbuendig. */}
          {dreiWege && (
            <button type="button" className={`${styles.pillDanger} ${styles.actionLinks}`}
              disabled={busy} onClick={onSecondary}>{secondaryLabel}</button>
          )}
          {!hideCancel && (
            <button type="button" className={styles.pill} disabled={busy} onClick={onCancel}>{cancelLabel}</button>
          )}
          <button type="button" className={confirmClass} disabled={busy} onClick={onConfirm}>
            {busy ? (busyLabel ?? confirmLabel) : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
